export { LocatorTabs, TAB_LABEL_IDS, getLocatorPanelId } from './locator-tabs';
